import React from 'react';
import SEO from '../components/shared/SEO';

const ConfidentialitePage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO 
        title="Politique de Confidentialité"
        description="Politique de confidentialité et protection des données personnelles - Foulées Vertes"
        noindex={true}
      />
      
      <div className="max-w-4xl mx-auto px-4 py-16">
        <h1 className="text-4xl font-neuropolitical font-bold text-gray-900 mb-8">Politique de Confidentialité</h1>
        
        <div className="bg-white rounded-2xl shadow-sm p-8 space-y-8">
          {/* Introduction */}
          <section>
            <p className="text-gray-600 leading-relaxed">
              Foulées Vertes accorde une grande importance à la protection de vos données personnelles. Cette politique de confidentialité vous informe sur la manière dont nous collectons, utilisons et protégeons vos informations personnelles conformément au Règlement Général sur la Protection des Données (RGPD).
            </p>
          </section>

          {/* Responsable du traitement */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Responsable du traitement</h2>
            <p className="text-gray-600 leading-relaxed">
              Le responsable du traitement des données personnelles est :
            </p>
            <ul className="mt-4 space-y-2 text-gray-600">
              <li><strong>Foulées Vertes</strong></li>
              <li>[Adresse à compléter], 63000 Clermont-Ferrand</li>
              <li>Email : contact@fouleesvertes.fr</li>
              <li>Téléphone : 04 73 91 72 20</li>
            </ul>
          </section>

          {/* Données collectées */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Données collectées</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Nous collectons les données suivantes :
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-600">
              <li><strong>Données d'identification :</strong> nom, prénom, adresse email, numéro de téléphone</li>
              <li><strong>Données de navigation :</strong> adresse IP, type de navigateur, pages visitées, durée de visite</li>
              <li><strong>Données de réservation :</strong> informations relatives à vos rendez-vous pour l'analyse de foulée</li>
            </ul>
          </section>

          {/* Finalités */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Finalités du traitement</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Vos données personnelles sont collectées pour les finalités suivantes :
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-600">
              <li>Gestion des demandes de rendez-vous et des réservations</li>
              <li>Réponse à vos demandes de contact</li>
              <li>Amélioration de nos services et de notre site web</li>
              <li>Envoi d'informations commerciales (avec votre consentement)</li>
              <li>Établissement de statistiques de visites</li>
            </ul>
          </section>

          {/* Base légale */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Base légale du traitement</h2>
            <p className="text-gray-600 leading-relaxed">
              Le traitement de vos données personnelles est fondé sur :
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-600 mt-4">
              <li><strong>Votre consentement</strong> pour l'envoi de communications commerciales</li>
              <li><strong>L'exécution d'un contrat</strong> pour la gestion des réservations</li>
              <li><strong>Notre intérêt légitime</strong> pour l'amélioration de nos services</li>
            </ul>
          </section>

          {/* Durée de conservation */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Durée de conservation</h2>
            <p className="text-gray-600 leading-relaxed">
              Vos données personnelles sont conservées pendant une durée n'excédant pas celle nécessaire aux finalités pour lesquelles elles sont collectées :
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-600 mt-4">
              <li><strong>Données clients :</strong> 3 ans après le dernier contact</li>
              <li><strong>Données de navigation :</strong> 13 mois maximum</li>
              <li><strong>Données de réservation :</strong> 3 ans après le rendez-vous</li>
            </ul>
          </section>

          {/* Destinataires */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Destinataires des données</h2>
            <p className="text-gray-600 leading-relaxed">
              Vos données personnelles sont destinées uniquement au personnel habilité de Foulées Vertes. Elles ne sont jamais vendues ni transmises à des tiers à des fins commerciales.
            </p>
            <p className="text-gray-600 leading-relaxed mt-4">
              Nous pouvons faire appel à des sous-traitants (hébergeur, outil de réservation) qui agissent en notre nom et selon nos instructions, dans le respect du RGPD.
            </p>
          </section>

          {/* Vos droits */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Vos droits</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Conformément au RGPD, vous disposez des droits suivants :
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-600">
              <li><strong>Droit d'accès :</strong> obtenir une copie de vos données personnelles</li>
              <li><strong>Droit de rectification :</strong> corriger vos données inexactes ou incomplètes</li>
              <li><strong>Droit à l'effacement :</strong> demander la suppression de vos données</li>
              <li><strong>Droit à la limitation :</strong> limiter le traitement de vos données</li>
              <li><strong>Droit à la portabilité :</strong> recevoir vos données dans un format structuré</li>
              <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données</li>
            </ul>
            <p className="text-gray-600 leading-relaxed mt-4">
              Pour exercer ces droits, contactez-nous à : <a href="mailto:contact@fouleesvertes.fr" className="text-emerald-700 hover:underline">contact@fouleesvertes.fr</a>
            </p>
          </section>

          {/* Cookies */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Cookies</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Notre site utilise des cookies pour :
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-600">
              <li><strong>Cookies essentiels :</strong> nécessaires au fonctionnement du site (préférences de thème)</li>
              <li><strong>Cookies analytiques :</strong> pour mesurer l'audience et améliorer le site</li>
            </ul>
            <p className="text-gray-600 leading-relaxed mt-4">
              Vous pouvez configurer votre navigateur pour refuser les cookies ou être alerté lorsqu'un cookie est déposé.
            </p>
          </section>

          {/* Sécurité */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Sécurité des données</h2>
            <p className="text-gray-600 leading-relaxed">
              Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre tout accès non autorisé, modification, divulgation ou destruction.
            </p>
          </section>

          {/* Réclamation */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Réclamation</h2>
            <p className="text-gray-600 leading-relaxed">
              Si vous estimez que le traitement de vos données personnelles constitue une violation du RGPD, vous avez le droit d'introduire une réclamation auprès de la CNIL (Commission Nationale de l'Informatique et des Libertés) :
            </p>
            <ul className="mt-4 space-y-2 text-gray-600">
              <li><strong>Site web :</strong> <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-emerald-700 hover:underline">www.cnil.fr</a></li>
              <li><strong>Adresse :</strong> 3 Place de Fontenoy - TSA 80715 - 75334 Paris Cedex 07</li>
            </ul>
          </section>

          {/* Mise à jour */}
          <section className="pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500">
              Dernière mise à jour : Janvier 2025
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ConfidentialitePage;